//chapter1
export default {
    id : 15,//chapter number
    title : '15. 반도체 패키지 발전에 따른 공정 변화 (1)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/15/videos/a15.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '반도체 제품에 대한 요구',
            ],
            body2 : [
                '반도체 제품에 대한 요구에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/15/videos/15.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '모든 반도체 제품은 웨이퍼 쏘잉 공정 후 다음 공정이 진행된다.',//html available
                    answer : "2",
                    explain : '웨이퍼 레벨 패키지는 몰딩 공정이 완료된 후에 웨이퍼 쏘잉이 진행이 된다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '웨이퍼 쏘잉은 웨이퍼의 두께와 관계없이 회전하는 블레이드를 이용해서 작업이 진행이 된다.',//html available
                    answer : "2",
                    explain : '얇은 웨이퍼의 경우에는 블레이드로 쏘잉할 경우 chipping 현상이 발생할 수 있어서 레이저를 이용해서 쏘잉을 진행한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>반도체 제품에 대한 요구<br>
                        - 반도체의 고용량, 박형화를 구현하기 위해 MCP(Multi Chip Packaging), SiP(System In Package), POP(Package On Package) 등의 고집적 패키지 기술 출현<br>
                        - CPU, DRAM, 플래시 메모리, ASIC 디바이스 등의 소자를 하나로 패키징하는 SiP(System in Package) 기술발전<br>
                        - 3D 기술은 PoP(Package on Package), CoC(Chip on Chip), WoW(Wafer on Wafer) 등으로 확대<br>
                        - 3D SiP는 아날로그 소자의 RF소자나 각종 센서 소자를 PCB에 집적하는 방향<br>
                        - 웨이퍼 레벨 패키지, 패널 레벨 패키지 등의 대면적 패키징 방법이 적용되면서 트랜스퍼 몰딩 대신 컴프레션 몰딩 방법이 적용됨</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/15/videos/a15.mp4',
        },
    ]
}